import Api from "../axios";

export default async function apiSummaryReport(employeeId, startDate, endDate) {
  return await Api.get(
    `/summary_report?employee_id=${employeeId}&start_date=${startDate}&end_date=${endDate}`
  );
}
